import { useMutation } from "@tanstack/react-query";
import { ContactService } from "../../services/api";
import { useEffect, useState } from "react";
import { Contact } from "../../services/swagger";
import FieldLabel from "../atoms/FieldLabel";
import { useTranslation } from "react-i18next";
import { Box, TableCell } from "@mui/material";
import DataTable from "../organisms/DataTable";
import { useNavigate } from "react-router";

interface CompanyContactsProps {
  companyId: string;
}

export default function CompanyContacts(props: CompanyContactsProps) {
  const { t } = useTranslation("CompanyContacts");
  const { t: tContact } = useTranslation("Contact");
  const navigate = useNavigate();
  const [contactList, setContactList] = useState<Contact[]>([]);

  const { mutate: loadCompanyContacts } = useMutation({
    mutationFn: async () => {
      const res = await ContactService.getContactListByCompany({
        company: props.companyId,
      });
      return res.data.data;
    },
    onSuccess: (data) => {
      if (data) setContactList(data);
    },
  });

  useEffect(() => {
    loadCompanyContacts();
  }, []);

  return (
    <Box width={1}>
      <FieldLabel>{t("CompanyContacts")}</FieldLabel>
      <DataTable
        headers={[
          { field: "extRef", name: tContact("ExtRef"), type: "string" },
          {
            field: "firstName",
            name: tContact("Name"),
            type: "other",
            renderRowCell: (row: Contact) => (
              <TableCell
                sx={{
                  minWidth: 100,
                  maxWidth: 150,
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                }}
              >
                {[row.title, row.firstName, row.middleName, row.lastName]
                  .filter((e) => e)
                  .join(" ")}
              </TableCell>
            ),
          },
          { field: "position", name: tContact("Position"), type: "string" },
        ]}
        filterTemplate={[]}
        onRowClick={(contact: Contact) =>
          navigate(`/m/business/contacts/${contact._id}`)
        }
        loading={false}
        content={{
          docs: contactList,
          count: contactList.length,
        }}
      />
    </Box>
  );
}
